/**
 * ## Aux listeners
 *
 * @module src/controllers/auxx
 */

"use strict";

const notification = require("../../components/notification");
const l = require("../../common").localization;

let kd;

/**
 */
const init = (kdObj) => {
  kd = kdObj;
  kd.on("aux", (data) => {
    if (
      data.docs[0].hasOwnProperty("beanstalkFail") &&
      data.docs[0].beanstalkFail === 1
    ) {
      const opt = {
        position: "top",
        width: "90%",
        seconds: 0,
        block: "fullheader",
        h1: l.translate("Problem with adding to loyalty program."),
        body: l.translate(
          "An issue was detected. Please check your Email Marketing " +
            "token in the Guest List dashboard and make sure it matches what is found in " +
            "the Heartland Email Marketing dashboard."
        ),
        buttons: [
          {
            description: l.translate("Done"),
            value: "close",
          },
        ],
      };
      notification.create(opt, {}, (err, value) => {
        notification.destroy();
      });
    }
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/auxx/index.js
 **/